import AkoTrigger from '@/App/tiles/ForwardAccumulator/parts/RightPanel/common/AkoTrigger.tsx';
import EkiTrigger from '@/App/tiles/ForwardAccumulator/parts/RightPanel/common/EkiTrigger.tsx';
import Step from '@/App/tiles/ForwardAccumulator/parts/RightPanel/common/Step.tsx';
import Strike from '@/App/tiles/ForwardAccumulator/parts/RightPanel/common/Strike.tsx';

export const InputGroup2 = () => {
  return (
    <>
      <Strike />
      <AkoTrigger />
      <EkiTrigger />
      <Step />
    </>
  );
};
